module.exports = __webpack_public_path__ + "img/62ne.4c6c4880.svg";